import { z } from 'zod';
import {
  addressSchema,
  dateDmySchema,
  emailSchema,
  niNumberSchema,
  nonEmptyTrimmed,
  optionalTrimmed,
  phoneSchema,
} from './primitives.js';

export const TITLES = ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr', 'Prof', 'Other'] as const;
export const GENDERS = ['male', 'female', 'preferNotToSay'] as const;
export const GENDER_LABELS: Record<(typeof GENDERS)[number], string> = {
  male: 'Male',
  female: 'Female',
  preferNotToSay: 'Prefer Not to Say',
};
export const NATIONALITIES = [
  'British',
  'Irish',
  'Afghan',
  'Albanian',
  'Algerian',
  'American',
  'Argentine',
  'Australian',
  'Austrian',
  'Bangladeshi',
  'Belgian',
  'Brazilian',
  'Bulgarian',
  'Canadian',
  'Chinese',
  'Colombian',
  'Croatian',
  'Cypriot',
  'Czech',
  'Danish',
  'Dutch',
  'Egyptian',
  'Estonian',
  'Ethiopian',
  'Filipino',
  'Finnish',
  'French',
  'Georgian',
  'German',
  'Ghanaian',
  'Greek',
  'Hungarian',
  'Icelandic',
  'Indian',
  'Indonesian',
  'Iranian',
  'Iraqi',
  'Israeli',
  'Italian',
  'Jamaican',
  'Japanese',
  'Jordanian',
  'Kazakhstani',
  'Kenyan',
  'Korean',
  'Latvian',
  'Lebanese',
  'Lithuanian',
  'Luxembourgish',
  'Malaysian',
  'Maltese',
  'Mexican',
  'Moroccan',
  'Nepalese',
  'New Zealander',
  'Nigerian',
  'Norwegian',
  'Pakistani',
  'Palestinian',
  'Peruvian',
  'Polish',
  'Portuguese',
  'Romanian',
  'Russian',
  'Saudi Arabian',
  'Scottish',
  'Serbian',
  'Singaporean',
  'Slovak',
  'Slovenian',
  'Somali',
  'South African',
  'Spanish',
  'Sri Lankan',
  'Swedish',
  'Swiss',
  'Syrian',
  'Taiwanese',
  'Thai',
  'Tunisian',
  'Turkish',
  'Ugandan',
  'Ukrainian',
  'Uzbek',
  'Venezuelan',
  'Vietnamese',
  'Welsh',
  'Zimbabwean',
  'Other',
] as const;
export const PREFERRED_CONTACTS = ['call', 'email', 'text'] as const;

export const personalDetailsSchema = z.object({
  title: z.enum(TITLES, { required_error: 'Select a title' }),
  gender: z.enum(GENDERS, { required_error: 'Select a gender' }),
  forename: nonEmptyTrimmed('Forename', 80),
  middleName: optionalTrimmed(80),
  surname: nonEmptyTrimmed('Last name', 80),
  preferredName: optionalTrimmed(80),
  mobile: phoneSchema,
  email: emailSchema,
  address: addressSchema,
  dob: dateDmySchema,
  nationality: z.enum(NATIONALITIES),
  niNumber: niNumberSchema,
  preferredContact: z.enum(PREFERRED_CONTACTS),
});

export type PersonalDetails = z.infer<typeof personalDetailsSchema>;
